var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-left":"25px"}},_vm._l((_vm.getFields()),function(component,i){return _c('component-compiler',{key:("form-" + i),attrs:{"content":component}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }